"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const menuButtons_1 = require("../models/menuButtons");
const lists_1 = require("../models/lists");
class LibellesGrid extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "libelles",
            datatableName: "libellesdatatable",
            columns: [
                { id: "unid", header: (0, globals_1._)("N°"), width: 40, css: { "text-align": "right" }, sort: "int" },
                { id: "famille", editor: "text", header: (0, globals_1._)("Famille"), width: 200, sort: "text" },
                { id: "code", editor: "text", header: (0, globals_1._)("Code"), width: 100, sort: "int",
                    numberFormat: "111111", css: { "text-align": "right" } },
                { id: "libelle", editor: "text", header: (0, globals_1._)("Libellé"), width: 400, sort: "text" },
                { id: "langue", editor: "richselect", header: (0, globals_1._)("Langue"), width: 140, sort: "text",
                    options: lists_1.localesList
                }
            ],
            title: (0, globals_1._)("Libellés de l'application"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.dupliquerButton, menuButtons_1.supprimerButton],
            resizeColumn: true,
            searchFieldHint: (0, globals_1._)("Recherche par libellé ..."),
            urlData: globals_1.phpPath + "stddata.php?tname=libelles&option=list",
            saveData: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "stddata.php?tname=libelles&option=insertEmpty",
                "update": globals_1.phpPath + "stddata.php?tname=libelles&option=update",
                "delete": globals_1.phpPath + "stddata.php?tname=libelles&option=delete",
            },
            tname: "tname=libelles"
        });
    }
    dupliquer() {
        super.dupliquer("code");
    }
    ready() {
        let me = this;
        let menu = this.$$("stdGridMenu");
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insert,")) {
            menu.showMenuItem("button-add");
            menu.showMenuItem("button-dup");
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) {
            menu.showMenuItem("button-del");
        }
        let searchField = $$("search");
        searchField.show();
        searchField.attachEvent("onTimedKeyPress", function () {
            //get user input value
            var value = this.getValue().toLowerCase();
            me.currentGrid.filter(function (obj) {
                if (obj.libelle) {
                    return obj.libelle.toLowerCase().indexOf(value) != -1;
                }
                else
                    return true;
            });
        });
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
                case "button-dup":
                    me.dupliquer();
                    break;
            }
        });
    }
}
exports.default = LibellesGrid;
